import React, { useContext, useEffect, useState } from "react";
import global_context from "../../../static_vars";
import dayjs, { Dayjs } from "dayjs";
import { Stack } from "@mui/material";
import DatePicker from "../../../components/selectors/Shared/DateSelect";
import RoleSelect from "../../../components/selectors/RoleSelect";
import ServerSelect from "../../../components/selectors/ServerSelect";
import MultipleMetricsSelect from "../../../components/selectors/Shared/MetricsSelect";
import Box from "@mui/material/Box";
import PlayerTierlist from "../../../components/datagrids/Competitive/PlayerTierlist";
import OffseasonShortlist from "../../../components/datagrids/Offseason/OffseasonShortlist";
import FarsightApi from "../../../ApiWrapper";
import OffseasonShortlistSelect from "../../../components/selectors/Offseason/OffseasonShortlistSelect";

export default function Shortlists() {
    const context = useContext(global_context);
    const [state, setState] = useState({
        from: dayjs("2023-01-01"),
        until: dayjs(),
        shortList: undefined,
    });

    const handleFromChange = (newValue: Dayjs) => {
        setState({ ...state, from: newValue });
        context.state.current_competitive_from = newValue;
    };
    const handleUntilChange = (newValue: Dayjs) => {
        setState({ ...state, until: newValue });
        context.state.current_competitive_until = newValue;
    };

    return (
        <Stack
            direction={"column"}
            sx={{
                ml: "100px",
                width: window.innerWidth - 200 + "px",
                height: window.innerHeight - 120 + "px",
            }}
        >
            <Stack direction={"row"} alignItems={"space-evenly"} justifyContent={"flex-start"} alignSelf={"space-evenly"} spacing={5} sx={{ m: 2 }}>
                <DatePicker onChange={handleFromChange} value={state.from} label={"Games From"} />
                <DatePicker onChange={handleUntilChange} value={state.until} label={"Games Until"} />
                <OffseasonShortlistSelect onChange={(event: any, newValue: any) => setState({ ...state, shortList: newValue })} value={state.shortList} />
            </Stack>
            <Box sx={{ width: "100%", height: "100%" }}>
                <OffseasonShortlist from={state.from.unix()} until={state.until.unix()} shortlist={state.shortList} />
            </Box>
        </Stack>
    );
}
